import React from 'react';
import { Table } from 'react-bootstrap';
import TableRow from './TableRow';

const DynamicTable = ({ columns, data }) => {
  const getRowKey = (item, index) => {
    return item.id ?? `${item.file_name || 'row'}-${item.processed_at || index}-${index}`;
  };

  return (
    <div className="dynamic-table-wrapper">
      <Table bordered hover className="dynamic-table mb-0">
        <thead className="thead-color">
          <tr>
            {columns.map((col) => (
              <th key={col.accessor}>{col.header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <TableRow key={getRowKey(item, index)} item={item} columns={columns} />
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default DynamicTable;